import { render, staticRenderFns } from "./DiagramLegendNoCard.vue?vue&type=template&id=1ab46935&scoped=true&"
import script from "./DiagramLegendNoCard.vue?vue&type=script&lang=ts&"
export * from "./DiagramLegendNoCard.vue?vue&type=script&lang=ts&"
import style0 from "./DiagramLegendNoCard.vue?vue&type=style&index=0&id=1ab46935&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab46935",
  null
  
)

export default component.exports